import instance from "../../services/baseService";


export const getClientsList = async (page = 1, limit = 10, searchQuery = '') => {
    try {
        let url = `/api/v1/client/list/${page}/${limit}`;

        // Add search query if provided
        if (searchQuery && searchQuery.trim()) {
            url += `/${encodeURIComponent(searchQuery.trim())}`;
        }

        const response = await instance.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching clients list:', error);
        throw error;
    }
};


export const getPendingClientsList = async (page = 1, limit = 25, searchQuery = '') => {
    try {
        // Assuming you have a separate endpoint for pending clients
        // Adjust this URL based on your actual API structure
        let url = `/api/v1/client/pending/list/${page}/${limit}`;

        // Add search query if provided
        if (searchQuery && searchQuery.trim()) {
            url += `/${encodeURIComponent(searchQuery.trim())}`;
        }

        const response = await instance.get(url);
        return response.data;
    } catch (error) {
        console.error('Error fetching pending clients list:', error);
        throw error;
    }
};

export const CREATE_CLIENT_FIELDS = {
    client_name: {
        name: 'client_name',
        placeholder: 'Full Name',
        type: 'text',
        label: 'Full Name',
        required: true,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.,'"\-@#$/%&*!()?_]+$/,
        validationErrorMessage: 'Full name can include letters, spaces, and common special characters'
    },
    gstin: {
        name: 'gstin',
        placeholder: 'GST Number',
        type: 'text',
        label: 'GST Number',
        required: true,
        maxLength: 15,
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        validationErrorMessage: 'GST number must be in valid format (e.g., 22AAAAA0000A1Z5)'
    },
    phone: {
        name: 'phone',
        placeholder: 'Phone Number',
        type: 'text',
        label: 'Phone Number',
        required: false,
        maxLength: 15,
        pattern: /^[\+]?[1-9][\d]{0,15}$/,
        validationErrorMessage: 'Phone number should be valid with 10-15 digits'
    },
    ifsc_code: {
        name: 'ifsc_code',
        placeholder: 'IFSC Code',
        type: 'text',
        label: 'IFSC Code',
        required: false,
        maxLength: 15,
        pattern: /^[A-Za-z0-9]+$/,
        validationErrorMessage: 'IFSC Code must be Alpha numeric '
    },
    email: {
        name: 'email',
        placeholder: 'Email',
        type: 'text',
        label: 'Email',
        required: true,
        maxLength: 100,
        pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: 'Please enter a valid email address with lowercase letters only.'
    },
    from_email: {
        name: 'from_email',
        placeholder: 'POC Email',
        type: 'text',
        label: 'POC Email',
        required: false,
        maxLength: 100,
        pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: 'Please enter a valid email address with lowercase letters only.'
    },
    address: {
        name: 'address',
        placeholder: 'Address',
        type: 'text',
        label: 'Address',
        required: false,
        maxLength: 500,
        pattern: /^.*$/,
        validationErrorMessage: ''
    },
    city: {
        name: 'city',
        placeholder: 'City',
        type: 'text',
        label: 'City',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'City name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    state: {
        name: 'state',
        placeholder: 'State',
        type: 'text',
        label: 'State',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'State name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    country: {
        name: 'country',
        placeholder: 'Country',
        type: 'text',
        label: 'Country',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'Country name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    pan: {
        name: 'pan',
        placeholder: 'PAN Number',
        type: 'text',
        label: 'PAN Number',
        required: false,
        maxLength: 10,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        validationErrorMessage: 'PAN number must be in valid format (e.g., ABCDE1234F)'
    },
    gst_jurisdiction: {
        name: 'gst_jurisdiction',
        placeholder: 'Client GST Jurisdiction',
        type: 'text',
        label: 'Client GST Jurisdiction',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z0-9\s.,'()-]+$/,
        validationErrorMessage: 'GST jurisdiction should contain only alphanumeric characters and basic punctuation'
    },
    client_class: {
        name: 'client_class',
        placeholder: 'Client Class',
        type: 'select',
        label: 'Client Class',
        required: false,
        options: [
            { label: 'Corporate', value: 'Corporate' },
            { label: 'Class A1', value: 'Class A1' },
            { label: 'Class A', value: 'Class A' },
            { label: 'Class B1', value: 'Class B1' },
            { label: 'Class B', value: 'Class B' }
        ],
        validationErrorMessage: 'Please select a valid client class'
    },
    category: {
        name: 'category',
        placeholder: 'Category',
        type: 'select',
        label: 'Category',
        required: true,
        maxLength: 50,
        options: [
            { label: 'Regular', value: 'regular' },
            { label: 'Project Based', value: 'project_based' }
        ],
        validationErrorMessage: 'Please select a valid category',
        apiEndpoint: '/api/v1/client/category/create',
        fields: [
            {
                key: 'name',
                label: 'Category Name',
                required: true,
                maxLength: 80,
                placeholder: 'Enter category name'
            }
        ]
    },
    assignee_id: {
        name: 'assignee_id',
        placeholder: 'Assignee (Consultant)',
        type: 'select',
        label: 'Assignee (Consultant)',
        required: false,
        maxLength: 50,
        validationErrorMessage: 'Please select an assignee'
    },
    responsible_person_id: {
        name: 'responsible_person_id',
        placeholder: 'Responsible Person (Consultant)',
        type: 'select',
        label: 'Responsible Person (Consultant)',
        required: false,
        maxLength: 50,
        validationErrorMessage: 'Please select a responsible person'
    },
    poc_mail: {
        name: 'poc_mail',
        placeholder: 'POC Mail ID (Consultant)',
        type: 'text',
        label: 'POC Mail ID (Consultant)',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        validationErrorMessage: 'Please enter a valid email address'
    },
    approver_levels: {
        name: 'approver_levels',
        type: 'checkbox_group',
        label: 'Process Approval Hierarchy',
        required: true,
        maxLength: 100,
        validationErrorMessage: 'Please select at least one approval level'
    },
    is_active: {
        name: 'is_active',
        placeholder: 'Active',
        type: 'checkbox',
        label: 'Active',
        required: false,
        maxLength: 1,
        validationErrorMessage: 'Please specify if the client is active'
    },
    is_send_reconciliation_mail: {
        name: 'is_send_reconciliation_mail',
        placeholder: 'Send reconciliation mail',
        type: 'checkbox',
        label: 'Send reconciliation mail',
        required: false,
        maxLength: 1,
        validationErrorMessage: 'Please consider the field'
    }
};

export const UPDATE_CLIENT_FIELDS = {
    client_name: {
        name: 'client_name',
        placeholder: 'Full Name',
        type: 'text',
        label: 'Full Name',
        required: true,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.,'"\-@#$/%&*!()?_]+$/,
        validationErrorMessage: 'Full name can include letters, spaces, and common special characters'
    },
    gstin: {
        name: 'gstin',
        placeholder: 'GST Number',
        type: 'text',
        label: 'GST Number',
        required: true,
        maxLength: 15,
        pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        validationErrorMessage: 'GST number must be in valid format (e.g., 22AAAAA0000A1Z5)'
    },
    phone: {
        name: 'phone',
        placeholder: 'Phone Number',
        type: 'text',
        label: 'Phone Number',
        required: false,
        maxLength: 15,
        pattern: /^[\+]?[1-9][\d]{0,15}$/,
        validationErrorMessage: 'Phone number should be valid with 10-15 digits'
    },
    ifsc_code: {
        name: 'ifsc_code',
        placeholder: 'IFSC Code',
        type: 'text',
        label: 'IFSC Code',
        required: false,
        maxLength: 15,
        pattern: /^[A-Za-z0-9]+$/,
        validationErrorMessage: 'IFSC Code must be Alpha numeric '
    },
    email: {
        name: 'email',
        placeholder: 'Email',
        type: 'text',
        label: 'Email',
        required: true,
        maxLength: 100,
        pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: 'Please enter a valid email address with lowercase letters only.'
    },
    from_email: {
        name: 'from_email',
        placeholder: 'POC Email',
        type: 'text',
        label: 'POC Email',
        required: false,
        maxLength: 100,
        pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: 'Please enter a valid email address with lowercase letters only.'
    },
    address: {
        name: 'address',
        placeholder: 'Address',
        type: 'text',
        label: 'Address',
        required: false,
        maxLength: 500,
        pattern: /^.*$/,
        validationErrorMessage: ''
    },
    city: {
        name: 'city',
        placeholder: 'City',
        type: 'text',
        label: 'City',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'City name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    state: {
        name: 'state',
        placeholder: 'State',
        type: 'text',
        label: 'State',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'State name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    country: {
        name: 'country',
        placeholder: 'Country',
        type: 'text',
        label: 'Country',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z\s.'-]+$/,
        validationErrorMessage: 'Country name should only contain letters, spaces, dots, hyphens, and apostrophes'
    },
    pan: {
        name: 'pan',
        placeholder: 'PAN Number',
        type: 'text',
        label: 'PAN Number',
        required: false,
        maxLength: 10,
        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        validationErrorMessage: 'PAN number must be in valid format (e.g., ABCDE1234F)'
    },
    gst_jurisdiction: {
        name: 'gst_jurisdiction',
        placeholder: 'Client GST Jurisdiction',
        type: 'text',
        label: 'Client GST Jurisdiction',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z0-9\s.,'()-]+$/,
        validationErrorMessage: 'GST jurisdiction should contain only alphanumeric characters and basic punctuation'
    },
    client_class: {
        name: 'client_class',
        placeholder: 'Client Class',
        type: 'select',
        label: 'Client Class',
        required: false,
        options: [
            { label: 'Corporate', value: 'Corporate' },
            { label: 'Class A1', value: 'Class A1' },
            { label: 'Class A', value: 'Class A' },
            { label: 'Class B1', value: 'Class B1' },
            { label: 'Class B', value: 'Class B' }
        ],
        validationErrorMessage: 'Please select a valid client class'
    },
    category: {
        name: 'category',
        placeholder: 'Category',
        type: 'select',
        label: 'Category',
        required: true,
        maxLength: 50,
        options: [
            { label: 'Regular', value: 'regular' },
            { label: 'Project Based', value: 'project_based' }
        ],
        validationErrorMessage: 'Please select a valid category',
        apiEndpoint: '/api/v1/client/category/create',
        fields: [
            {
                key: 'name',
                label: 'Category Name',
                required: true,
                maxLength: 80,
                placeholder: 'Enter category name'
            }
        ]
    },
    assignee_id: {
        name: 'assignee_id',
        placeholder: 'Assignee(Consultant)',
        type: 'select',
        label: 'Assignee(Consultant)',
        required: false,
        maxLength: 50,
        validationErrorMessage: 'Please select an assignee'
    },
    responsible_person_id: {
        name: 'responsible_person_id',
        placeholder: 'Responsible Person (Consultant)',
        type: 'select',
        label: 'Responsible Person (Consultant)',
        required: false,
        maxLength: 50,
        validationErrorMessage: 'Please select a responsible person'
    },
    poc_mail: {
        name: 'poc_mail',
        placeholder: 'POC Mail ID (Consultant)',
        type: 'text',
        label: 'POC Mail ID (Consultant)',
        required: false,
        maxLength: 100,
        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        validationErrorMessage: 'Please enter a valid email address'
    },
    is_send_reconciliation_mail: {
        name: 'is_send_reconciliation_mail',
        type: 'checkbox',
        label: 'Send reconciliation mail',
        required: false,
        maxLength: 1,
        validationErrorMessage: 'Please consider the field'
    },
    approver_levels: {
        name: 'approver_levels',
        type: 'checkbox_group',
        label: 'Process Approval Hierarchy',
        required: true,
        maxLength: 100,
        validationErrorMessage: 'Please select at least one approval level'
    },

};

export const validateField = (fieldName, value, fieldConfig) => {
    if (!fieldConfig) return null;

    // Check if required field is empty
    if (fieldConfig.required && (!value || (typeof value === 'string' && value.trim() === ''))) {
        return `${fieldConfig.label} is required`;
    }

    // Skip other validations if field is not required and empty
    if (!fieldConfig.required && (!value || (typeof value === 'string' && value.trim() === ''))) {
        return null;
    }

    // Check max length for string values
    if (typeof value === 'string' && fieldConfig.maxLength && value.length > fieldConfig.maxLength) {
        return `${fieldConfig.label} must not exceed ${fieldConfig.maxLength} characters`;
    }

    // Check pattern validation for string values
    if (typeof value === 'string' && fieldConfig.pattern && !fieldConfig.pattern.test(value)) {
        return fieldConfig.validationErrorMessage;
    }

    // Special validation for checkbox_group (approver_levels)
    if (fieldConfig.type === 'checkbox_group' && Array.isArray(value)) {
        if (fieldConfig.required && value.length === 0) {
            return fieldConfig.validationErrorMessage;
        }
        if (fieldConfig.maxLength && value.length > fieldConfig.maxLength) {
            return `Maximum ${fieldConfig.maxLength} selections allowed`;
        }
    }

    return null;
};

// Helper function to validate all fields
export const validateAllFields = (formData, fieldsConfig) => {
    const errors = {};

    Object.keys(fieldsConfig).forEach(fieldName => {
        const error = validateField(fieldName, formData[fieldName], fieldsConfig[fieldName]);
        if (error) {
            errors[fieldName] = error;
        }
    });

    return errors;
};


export const createClient = async (clientData) => {
    try {
        const response = await instance.post('/api/v1/client/create', clientData);
        return response.data;
    } catch (error) {
        console.error('Error creating client:', error);
        throw error;
    }
};

export const viewClient = async (clientId) => {
    try {
        const response = await instance.get(`/api/v1/client/view/${clientId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching client:', error);
        throw error;
    }
};

export const updateClient = async (clientId, clientData) => {
    try {
        const dataToSend = {
            ...clientData,
            assignee_id: clientData.assignee_id === '' ? null : clientData.assignee_id,
            responsible_person_id: clientData.responsible_person_id === '' ? null : clientData.responsible_person_id,
        };

        const response = await instance.post(`/api/v1/client/update/${clientId}`, dataToSend);
        return response.data;
    } catch (error) {
        console.error('Error updating client:', error);
        throw error;
    }
};

export const uploadProfilePhoto = async (userId, file) => {
    const formData = new FormData();
    formData.append("photo", file);

    try {
        const response = await instance.post(`/api/v1/client/photo/change/${userId}`, formData);
        return response.data;
    } catch (error) {
        console.error("Error uploading profile photo:", error);
        throw error;
    }
};

export const insertDocument = async (profileId, data) => {
    const formData = new FormData();
    formData.append("document_type", data.document_type);
    formData.append("document_number", data.document_number);
    formData.append("file", data.photo);
    if (data?.expires_date) {
        formData.append("expires_date", data.expires_date);
        formData.append("notify_day_before", data.notify_day_before);
    }
    const response = await instance.post(`/api/v1/client/documents/add/${profileId}`, formData);
    return response.data;
};

export const listDocument = async (profileId, page = 1, perpage = 25) => {
    const response = await instance.post(`/api/v1/client/documents/list/${profileId}`, {
        page,
        perpage,
    });
    return response.data;
};

export const listKYCTypes = async () => {
    const response = await instance.get("/api/v1/client/document/type/list", {
    });
    return response.data;
};

export const deleteDocument = async (profileId, kycId) => {
    const response = await instance.get(`/api/v1/client/documents/delete/${profileId}/${kycId}`);
    return response.data;
};

export const updateClientStatus = async (clientId, isActive) => {
    const response = await instance.post(`/api/v1/client/status/change/${clientId}`, {
        is_active: isActive
    });
    return response.data;
};

export const approveClient = async (profileId, isApproved) => {
    const endpoint = `/api/v1/client/approve/${profileId}`
    const payload = { active: isApproved };
    const response = await instance.post(endpoint, payload);
    return response.data;
};

export const listCategoryTypes = async () => {
    const response = await instance.get("/api/v1/client/category/list", {
    });
    return response.data;
};